export { default as Homepage } from './homepage/Homepage';
export { default as SetYourBudget } from './set-your-budget/SetYourBudget';
export { default as PeoplesBudget } from './peoples-budget/PeoplesBudget';
export { default as TermsAndConditions } from './terms-and-conditions/TermsAndConditions';
export { default as PrivacyPolicy } from './privacy-policy/PrivacyPolicy';
export { default as Accessibility } from './accessibility/Accessibility';
export { default as HowToUse } from './how-to-use/HowToUse';
export { default as PeoplesBudgetIndividual } from './peoples-budget/PeoplesBudgetIndividual';
export { default as CouncilBudget } from './council-budget/CouncilBudget';
export { default as BudgetReports } from './budget-reports/BudgetReports';



// WEBPACK FOOTER //
// ./src/pages/index.js